import React from 'react';
import PropTypes from 'prop-types';
import Portal from 'react-portal';
import ColorSkinWrapper from '../colorSkinWrapper';
import Modal from './Modal';

const ModalPortal = ({ bookmakerName, visible, ...props }) => (
    <Portal isOpened={visible}>
        <ColorSkinWrapper bookmakerName={bookmakerName}>
            <Modal {...props} visible={visible} />
        </ColorSkinWrapper>
    </Portal>
);

ModalPortal.defaultProps = {
    visible: false,
};

ModalPortal.propTypes = {
    bookmakerName: PropTypes.string.isRequired,
    visible: PropTypes.bool,
};

export default ModalPortal;



// WEBPACK FOOTER //
// /src/js/common/modal/ModalPortal.jsx